import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'base-form-kit-label',
    imports: [CommonModule, TranslateModule],
    template: `
    <ng-container *ngIf="!hasLabelContent">
      {{ label | translate }}
      <span class="ignore-dark-color" *ngIf="hasCurrency">{{
        '(' + (currency | translate) + ')'
      }}</span>
    </ng-container>
    <span
      class="ignore-dark-color"
      #labelContent
      [style.display]="hasLabelContent ? 'inline' : 'none'"
    >
      <ng-content></ng-content>
    </span>
  `
})
export class BaseFormKitLabelComponent {
  readonly labelContent = viewChild<ElementRef>('labelContent');
  @Input() label: string;
  @Input() hasLabelContent: boolean = false;
  @Input() hasCurrency: boolean = false;
  @Input() currency: string = 'common.currency';

  ngAfterContentChecked(): void {
    this.hasLabelContent =
      !!this.labelContent()?.nativeElement?.childNodes?.length;
  }
}
